var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-button back-btn-top",on:{"click":_vm.goBack}},[_c('span',{staticClass:"el-icon-arrow-left"}),_c('span',{staticClass:"back-text"},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }